import { useEffect } from 'react'
import type { Control, UseFormClearErrors, UseFormTrigger, UseFormWatch } from 'react-hook-form'
import { useWatch } from 'react-hook-form'
import type { MultiHotelFormState } from '../../SearchForm/MultiHotelSearchForm/types'

type UseMultiHotelFormProps = {
  control: Control<MultiHotelFormState>
  watch: UseFormWatch<MultiHotelFormState>
  clearErrors: UseFormClearErrors<MultiHotelFormState>
  trigger: UseFormTrigger<MultiHotelFormState>
  initialValues: MultiHotelFormState
  updateFormValues?: (values: MultiHotelFormState) => void
}

const useMultiHotelFormSubmitValues = ({
  control,
  watch,
  clearErrors,
  trigger,
  initialValues,
  updateFormValues,
}: UseMultiHotelFormProps) => {
  const watchHotels = useWatch({
    control,
    name: 'hotels',
    defaultValue: initialValues.hotels,
  })

  const watchTravelers = useWatch({
    control,
    name: 'travelers',
    defaultValue: initialValues.travelers,
  })

  useEffect(() => {
    const subscription = watch((value) => {
      if (updateFormValues) {
        updateFormValues(value as MultiHotelFormState)
      }
    })
    return () => subscription.unsubscribe()
  }, [watch, updateFormValues])

  useEffect(() => {
    if (watchHotels.length > 0) {
      watchHotels.forEach((_, index) => {
        clearErrors(`hotels.${index}.endLocation`)
        clearErrors(`hotels.${index}.startDate`)
        clearErrors(`hotels.${index}.endDate`)
      })
    }
  }, [clearErrors, watchHotels])

  useEffect(() => {
    void trigger('travelers.children')
  }, [trigger, watchTravelers])

  return {
    watchHotels,
    watchTravelers,
  }
}

export default useMultiHotelFormSubmitValues
